import React, { useEffect, useState, FunctionComponent } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Card } from 'transfix-ui/components/Card'
import { ILaneHistoryState } from 'types/carrier'
import { fetchLaneHistory } from 'apps/carrier/utils/actions/laneHistory'
import { IStore } from 'apps/carrier/utils/reducers'
import { LanesTable } from './LanesTable'

interface ISelector extends ILaneHistoryState {
  carrierId?: string
}

const PER_PAGE = 10

export const LaneHistory: FunctionComponent = () => {
  const dispatch = useDispatch()
  const [pageCount, setPageCount] = useState(0)
  const { carrierId, ...state } = useSelector<IStore, ISelector>(({ carrier, laneHistory }) => ({
    ...laneHistory,
    carrierId: carrier.carrierDetails?.id,
  }))
  const { error, fetching, firstLoad, lanes, totalCount } = state

  useEffect(() => {
    if (carrierId) dispatch(fetchLaneHistory(carrierId, { perPage: PER_PAGE, pageCount }))
  }, [carrierId, pageCount])

  return (
    <Card>
      <div className='row pv4'>
        <h3 className='fl mb0 mt2'>Lane History</h3>
      </div>
      <LanesTable
        lanes={lanes}
        firstLoad={firstLoad}
        totalCount={totalCount}
        fetching={fetching}
        pageCount={pageCount}
        setPageCount={setPageCount}
        perPage={PER_PAGE}
        error={error}
      />
    </Card>
  )
}
